// index.js or main file
import React, {useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import Login from './pages/login/login';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import UserRules from './pages/rules/rules';
import ThankYou from './pages/thankyou/thankyou';
import StaticGamePage from './pages/game/StaticGamePage';
import USER from './pages/dddUI/user';

import ResultPage from './pages/result/ResultPage';
import Intro from './pages/intro/intro';
import UnhealthyThankYouPage from './pages/game/UnhealthyThankYouPage';


function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    body.classList.remove("common-bg");
    if (location.pathname.startsWith("/admin")) {
      body.style.backgroundImage = "";
      body.style.backgroundSize = "";
      body.style.backgroundPosition = "";
      body.style.backgroundRepeat = "";
    }
  }, [location]);
}


function App() {
  usePageBackground();

   return (
    <Provider store={store}>
      <Routes>
        {/* Public routes wrapped with DDDUI */}
        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/rules" element={<UserRules/>} />
              <Route path="/intro" element={<Intro/>} />
              <Route path="/game" element={<StaticGamePage/>} />
              <Route path="/game/stage/:stageId" element={<StaticGamePage/>} />
              <Route path="/result" element={<ResultPage/>} />
              <Route path="/unhealthy-thankyou" element={<UnhealthyThankYouPage/>} />
              <Route path="/thankyou" element={<ThankYou/>} />
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();
